var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 2)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 15.2,
    y1: 0.8,
    y2: 0.8,
    stroke: "#F8F7F2",
    strokeLinecap: "square",
    strokeWidth: 3,
    transform: "rotate(45 1.023 2.676)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.6,
    x2: -0.6,
    y1: 6,
    y2: 6,
    stroke: "#F8F7F2",
    strokeLinecap: "square",
    strokeWidth: 3,
    transform: "rotate(135 7 6)"
  }))));
}

export default __webpack_public_path__ + "media/news/images/icon_selected-14c82347a3ae45b95526a66fb644a552.svg";
export { SvgIconSelected as ReactComponent };